// GENERATED — run `node scripts/generate-demo-docs.mjs` to regenerate
import type { DocumentViewMetadata } from "@/shared/utils/documentUtils";

export const DEMO_DOCUMENT_METADATA: Record<number, DocumentViewMetadata> = {
  1001: {
    id: 1001,
    extractionStatus: "completed",
    documentType: "death_certificate",
    fileName: "Death_Certificate_Margaret_Whitfield.pdf",
    displayName: "Death Certificate",
    smartSummary: {
      status: "completed",
      summary:
        "Death certificate for Margaret Eleanor Whitfield, aged 84, who passed on February 17, 2026 in Bedford, NY. Marital status listed as widowed. Certificate issued March 2, 2026 by Westchester County. Surviving spouse: Robert Arthur Whitfield.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      decedent_information: {
        full_name: "Margaret Eleanor Whitfield",
        date_of_birth: "October 22, 1941",
        date_of_death: "February 17, 2026",
        place_of_death: "Bedford, NY",
        marital_status: "Widowed",
        age_at_death: "84",
        sex: "Female",
        residence_address: "47 Hawthorne Lane, Bedford, NY 10506",
      },
      administrative_information: {
        certificate_number: "2026-NY-08-04821",
        date_issued: "March 2, 2026",
        state_filed: "New York",
        county_filed: "Westchester County",
        registrar_name: "James T. Hartley",
      },
      other_details: {
        occupation: "Retired Educator",
        birthplace: "Westchester County, New York",
        education_level: "Master's Degree",
        residence_address: "47 Hawthorne Lane, Bedford, NY 10506",
      },
      surviving_spouse: {
        name: "Robert Arthur Whitfield",
      },
    },
    specificDocCitations: {
      "decedent_information.full_name": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.1111111111111111,
            width: 0.17348529411764704,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.date_of_birth": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.1590909090909091,
            width: 0.11363235294117646,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.date_of_death": [
        {
          page: 1,
          bbox: {
            left: 0.2957516339869281,
            top: 0.1590909090909091,
            width: 0.12038235294117645,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.age_at_death": [
        {
          page: 1,
          bbox: {
            left: 0.5049019607843137,
            top: 0.1590909090909091,
            width: 0.016352941176470587,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.sex": [
        {
          page: 1,
          bbox: {
            left: 0.6094771241830066,
            top: 0.1590909090909091,
            width: 0.04858823529411765,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.marital_status": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.20202020202020202,
            width: 0.06010294117647058,
            height: 0.010511363636363638,
          },
        },
      ],
      "decedent_information.place_of_death": [
        {
          page: 1,
          bbox: {
            left: 0.5049019607843137,
            top: 0.20202020202020202,
            width: 0.07966176470588233,
            height: 0.010511363636363638,
          },
        },
      ],
      "other_details.residence_address": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.24494949494949494,
            width: 0.261,
            height: 0.010511363636363638,
          },
        },
      ],
      "other_details.occupation": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.2878787878787879,
            width: 0.11033823529411765,
            height: 0.010511363636363638,
          },
        },
      ],
      "other_details.birthplace": [
        {
          page: 1,
          bbox: {
            left: 0.5049019607843137,
            top: 0.2878787878787879,
            width: 0.19894117647058823,
            height: 0.010511363636363638,
          },
        },
      ],
      "surviving_spouse.name": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.37373737373737376,
            width: 0.14932352941176472,
            height: 0.010511363636363638,
          },
        },
      ],
      "administrative_information.certificate_number": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.43434343434343436,
            width: 0.123,
            height: 0.010511363636363638,
          },
        },
      ],
      "administrative_information.date_issued": [
        {
          page: 1,
          bbox: {
            left: 0.5049019607843137,
            top: 0.43434343434343436,
            width: 0.094,
            height: 0.010511363636363638,
          },
        },
      ],
      "administrative_information.state_filed": [
        {
          page: 1,
          bbox: {
            left: 0.7140522875816994,
            top: 0.43434343434343436,
            width: 0.06027941176470588,
            height: 0.010511363636363638,
          },
        },
      ],
      "administrative_information.registrar_name": [
        {
          page: 1,
          bbox: {
            left: 0.08660130718954248,
            top: 0.4772727272727273,
            width: 0.2851911764705882,
            height: 0.010511363636363638,
          },
        },
      ],
    },
    createdAt: "2026-02-17T18:30:00.000Z",
  },
  1002: {
    id: 1002,
    extractionStatus: "completed",
    documentType: "will",
    fileName: "Last_Will_and_Testament_MEW_2023.pdf",
    displayName: "Last Will and Testament",
    smartSummary: {
      status: "completed",
      summary:
        "Last Will and Testament executed November 14, 2023. Robert Arthur Whitfield named primary executor with Catherine Whitfield-Marsh as successor. Residuary estate divided: 50% to Robert, remaining 50% equally among three children. Specific bequests include jewelry, the Lexus, and Skaneateles furnishings.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      document_background: {
        date_signed: "2023-11-14",
        date_signed_raw: "November 14, 2023",
        state: "New York",
        location_signed: { city: "Skaneateles", county: "Onondaga", state: "New York" },
        is_self_proving: true,
        self_proving_timing: "at_execution",
        revokes_prior_wills: true,
        testator_name_as_signed: "Margaret Eleanor Whitfield",
        also_known_as: ["Peggy Whitfield"],
        drafting_attorney: { name: "James Hartford", firm: "Hartford & Associates LLP" },
        page_count: 12,
        page_continuity_flag: true,
      },
      signing_and_witnesses: {
        attestation_clause_present: true,
        signature_at_end: true,
        text_after_signature: false,
        witness_count: 2,
      },
      executors: [
        {
          name: "Robert Arthur Whitfield",
          role: "executor",
          is_primary: true,
          relationship: "Spouse",
          bond_waiver: "waived",
          power_to_sell_real_property: true,
        },
        {
          name: "Catherine Whitfield-Marsh",
          role: "executor",
          is_primary: false,
          relationship: "Daughter",
          bond_waiver: "waived",
        },
      ],
      key_people: [
        {
          name: "Robert Arthur Whitfield",
          roles: ["executor"],
          relationship: "Spouse",
        },
        {
          name: "Catherine Whitfield-Marsh",
          roles: ["executor", "beneficiary"],
          relationship: "Daughter",
        },
        {
          name: "Andrew Whitfield",
          roles: ["beneficiary"],
          relationship: "Son",
        },
        {
          name: "Rebecca Whitfield-Chen",
          roles: ["beneficiary"],
          relationship: "Daughter",
        },
      ],
      specific_bequests: [
        {
          item_description: "Jewelry Collection (est. $42,000)",
          category: "jewelry",
          beneficiaries: [
            {
              name: "Catherine Whitfield-Marsh",
              percentage: 50,
            },
            {
              name: "Rebecca Whitfield-Chen",
              percentage: 50,
            },
          ],
        },
        {
          item_description: "2022 Lexus ES 350",
          category: "vehicle",
          beneficiaries: [
            {
              name: "Robert Arthur Whitfield",
              percentage: 100,
            },
          ],
        },
        {
          item_description: "Household Furnishings — 84 Lake Road, Skaneateles",
          category: "other",
          beneficiaries: [
            {
              name: "Andrew Whitfield",
              percentage: 100,
            },
          ],
        },
      ],
      residuary_estate: {
        distribution_scheme: "per_stirpes",
        survivorship_period: "30 days",
        beneficiaries: [
          {
            name: "Robert Arthur Whitfield",
            percentage: 50,
          },
          {
            name: "Catherine Whitfield-Marsh",
            percentage: 16.67,
          },
          {
            name: "Andrew Whitfield",
            percentage: 16.67,
          },
          {
            name: "Rebecca Whitfield-Chen",
            percentage: 16.67,
          },
        ],
      },
      trust_references: [
        {
          trust_name: "Margaret Eleanor Whitfield Revocable Living Trust",
          trust_date: "2020-06-15",
          relationship: "pour_over",
          is_pour_over: true,
        },
      ],
      witness_info: [
        { name: "Patricia Morrison", address: "112 Elm Street, Skaneateles, NY" },
        { name: "David Kowalski", address: "88 Main Street, Skaneateles, NY" },
      ],
      instructions_and_clauses: {
        funeral_instructions: { has_instructions: true, type: "burial", details: "At Lakeview Cemetery, Skaneateles" },
        debt_payment_direction: "All debts and funeral expenses to be paid from the residuary estate",
        tax_apportionment_clause: { has_clause: true, description: "Taxes apportioned pro rata among beneficiaries" },
        personal_property_memorandum_referenced: true,
      },
      real_property: [
        { address: "84 Lake Road, Skaneateles, NY 13152", property_type: "primary_residence", description: "Family lakehouse" },
      ],
    },
    specificDocCitations: {
      "document_background.date_signed": [
        {
          page: 1,
          bbox: {
            left: 0.18288888888888888,
            top: 0.14393939393939395,
            width: 0.11427450980392158,
            height: 0.009343434343434345,
          },
        },
      ],
      "document_background.state": [
        {
          page: 1,
          bbox: {
            left: 0.5599444444444444,
            top: 0.14393939393939395,
            width: 0.053581699346405234,
            height: 0.009343434343434345,
          },
        },
      ],
      "document_background.is_self_proving": [
        {
          page: 1,
          bbox: {
            left: 0.1912042483660131,
            top: 0.16414141414141414,
            width: 0.020692810457516336,
            height: 0.009343434343434345,
          },
        },
      ],
      "document_background.revokes_prior_wills": [
        {
          page: 1,
          bbox: {
            left: 0.6571209150326798,
            top: 0.16414141414141414,
            width: 0.020692810457516336,
            height: 0.009343434343434345,
          },
        },
      ],
      "executors.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.3741830065359477,
            top: 0.3282828282828283,
            width: 0.15298611111111113,
            height: 0.009927398989898991,
          },
        },
      ],
      "executors.1.name": [
        {
          page: 1,
          bbox: {
            left: 0.3741830065359477,
            top: 0.34595959595959597,
            width: 0.17076388888888888,
            height: 0.009927398989898991,
          },
        },
      ],
      "specific_bequests.0.item_description": [
        {
          page: 1,
          bbox: {
            left: 0.15359477124183007,
            top: 0.41414141414141414,
            width: 0.19072222222222224,
            height: 0.009659090909090909,
          },
        },
      ],
      "specific_bequests.1.item_description": [
        {
          page: 1,
          bbox: {
            left: 0.15359477124183007,
            top: 0.45075757575757575,
            width: 0.11151388888888891,
            height: 0.009659090909090909,
          },
        },
      ],
      "specific_bequests.2.item_description": [
        {
          page: 1,
          bbox: {
            left: 0.15359477124183007,
            top: 0.48737373737373735,
            width: 0.3172222222222222,
            height: 0.009659090909090909,
          },
        },
      ],
      "residuary_estate.beneficiaries.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.5909090909090909,
            width: 0.15298611111111113,
            height: 0.009927398989898991,
          },
        },
      ],
      "residuary_estate.beneficiaries.1.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6098484848484849,
            width: 0.17076388888888888,
            height: 0.009927398989898991,
          },
        },
      ],
      "residuary_estate.beneficiaries.2.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6287878787878788,
            width: 0.11211111111111112,
            height: 0.009927398989898991,
          },
        },
      ],
      "residuary_estate.beneficiaries.3.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6477272727272727,
            width: 0.15786111111111112,
            height: 0.009927398989898991,
          },
        },
      ],
    },
    createdAt: "2026-02-18T11:00:00.000Z",
  },
  1003: {
    id: 1003,
    extractionStatus: "completed",
    documentType: "trust",
    fileName: "MEW_Revocable_Living_Trust_2021.pdf",
    displayName: "Margaret E. Whitfield Revocable Living Trust",
    smartSummary: {
      status: "completed",
      summary:
        "Revocable Living Trust established March 8, 2021. Margaret serves as initial trustee; Robert Arthur Whitfield and Catherine Whitfield-Marsh named successor trustees. Five trust assets identified including the Bedford residence ($2.4M) and investment accounts. Spendthrift clause included. Distributions governed by HEMS standard.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      trust_information: {
        trust_name: "Margaret E. Whitfield Revocable Living Trust",
        trust_type: "REVOCABLE_LIVING",
        date_created: "March 8, 2021",
        state_created: "New York",
        governing_law_state: "New York",
        grantor_name: "Margaret Eleanor Whitfield",
        grantor_name_as_printed: "Margaret Eleanor Whitfield",
        trust_ein: "84-2917365",
      },
      trustees: [
        {
          name: "Margaret Eleanor Whitfield",
          type: "individual",
          role: "acting_trustee",
          is_primary: true,
          bond_waiver: "waived",
          power_to_sell_real_property: true,
        },
      ],
      successor_trustees: [
        {
          name: "Robert Arthur Whitfield",
          order: 1,
        },
        {
          name: "Catherine Whitfield-Marsh",
          order: 2,
        },
      ],
      nominated_trustees: [
        {
          name: "First National Bank of Bedford",
          type: "corporate",
          context: "Corporate successor",
        },
      ],
      trustee_succession_terms: {
        trigger: "Incapacity or death of all individual trustees",
        clause_text:
          "If no individual trustee is able to serve, First National Bank of Bedford shall serve as successor trustee.",
      },
      beneficiaries: [
        {
          name: "Margaret Eleanor Whitfield",
          beneficiary_type: "primary",
          is_income_beneficiary: true,
          distribution_conditions: "During lifetime",
        },
        {
          name: "Robert Arthur Whitfield",
          beneficiary_type: "remainder",
          is_principal_beneficiary: true,
          percentage: 50,
          bequest_description: "Residuary share of trust estate",
        },
        {
          name: "Catherine Whitfield-Marsh",
          beneficiary_type: "remainder",
          is_principal_beneficiary: true,
          percentage: 11.67,
        },
        {
          name: "Andrew Whitfield",
          beneficiary_type: "remainder",
          is_principal_beneficiary: true,
          percentage: 11.67,
        },
        {
          name: "Rebecca Whitfield-Chen",
          beneficiary_type: "remainder",
          is_principal_beneficiary: true,
          percentage: 11.67,
        },
        {
          name: "Bedford Community Foundation",
          beneficiary_type: "charitable",
          percentage: 5,
          organization_type: "civic",
        },
      ],
      distribution: {
        distribution_scheme: "per_stirpes",
        distribution_timing: "Upon death of grantor",
        survivorship_period: "30 days",
      },
      sub_trusts: [
        {
          name: "Whitfield Family Education Trust",
          beneficiaries: [
            { name: "Andrew Whitfield", relationship: "grandchild" },
            { name: "Rebecca Whitfield-Chen", relationship: "grandchild" },
          ],
          funding_formula: "25% of residuary estate",
        },
      ],
      trust_assets: [
        {
          asset_description: "47 Hawthorne Lane, Bedford, NY — Residential",
          asset_type: "real_estate",
          asset_category: "REAL_PROPERTY",
          estimated_value: 2400000,
          property_address: "47 Hawthorne Lane, Bedford, NY 10506",
        },
        {
          asset_description: "84 Lake Road, Skaneateles, NY — Vacation Home",
          asset_type: "real_estate",
          asset_category: "REAL_PROPERTY",
          estimated_value: 385000,
        },
        {
          asset_description: "Chase Savings Account xxxxxx6271",
          asset_type: "bank_account",
          asset_category: "FINANCIAL_ACCOUNT",
          institution_name: "Chase",
        },
        {
          asset_description: "M&T Bank CD xxxxxx9912",
          asset_type: "bank_account",
          asset_category: "FINANCIAL_ACCOUNT",
          institution_name: "M&T Bank",
        },
        {
          asset_description: "Charles Schwab Brokerage xxxxxx8847",
          asset_type: "brokerage",
          asset_category: "FINANCIAL_ACCOUNT",
          institution_name: "Charles Schwab",
        },
      ],
      trust_provisions: {
        has_spendthrift_clause: true,
        distribution_standard: "Health, Education, Maintenance, Support",
        debt_expense_payment_direction:
          "All debts and expenses to be paid from the residuary trust estate",
        tax_apportionment_clause: {
          has_clause: true,
          description:
            "All estate and inheritance taxes shall be apportioned among the beneficiaries in proportion to their respective shares",
        },
        no_contest_clause: {
          has_clause: true,
          clause_text:
            "Any beneficiary who contests this trust shall forfeit their entire interest",
        },
      },
      pour_over_will: {
        has_pour_over_will: true,
        will_date: "November 14, 2023",
        testator_name: "Margaret Eleanor Whitfield",
      },
      amendments: [
        {
          amendment_detected: true,
          amendment_date: "November 14, 2023",
          amendment_scope: "TRUSTEE_CHANGE",
          description:
            "Addition of Catherine Whitfield-Marsh as second successor trustee",
        },
      ],
    },
    specificDocCitations: {
      "trust_information.trust_type": [
        {
          page: 1,
          bbox: {
            left: 0.17601470588235293,
            top: 0.14393939393939395,
            width: 0.12993464052287582,
            height: 0.009343434343434345,
          },
        },
      ],
      "trust_information.state_created": [
        {
          page: 1,
          bbox: {
            left: 0.5599444444444444,
            top: 0.14393939393939395,
            width: 0.053581699346405234,
            height: 0.009343434343434345,
          },
        },
      ],
      "trust_information.date_created": [
        {
          page: 1,
          bbox: {
            left: 0.2187124183006536,
            top: 0.16414141414141414,
            width: 0.08355555555555556,
            height: 0.009343434343434345,
          },
        },
      ],
      "trustees.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.38235294117647056,
            top: 0.34595959595959597,
            width: 0.17463888888888887,
            height: 0.009927398989898991,
          },
        },
      ],
      "successor_trustees.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.38235294117647056,
            top: 0.36237373737373735,
            width: 0.15298611111111113,
            height: 0.009927398989898991,
          },
        },
      ],
      "successor_trustees.1.name": [
        {
          page: 1,
          bbox: {
            left: 0.38235294117647056,
            top: 0.3787878787878788,
            width: 0.17076388888888888,
            height: 0.009927398989898991,
          },
        },
      ],
      "trust_assets.0.asset_description": [
        {
          page: 1,
          bbox: {
            left: 0.1437908496732026,
            top: 0.44823232323232326,
            width: 0.32419444444444445,
            height: 0.009659090909090909,
          },
        },
      ],
      "trust_assets.1.asset_description": [
        {
          page: 1,
          bbox: {
            left: 0.1437908496732026,
            top: 0.46464646464646464,
            width: 0.2834444444444445,
            height: 0.009659090909090909,
          },
        },
      ],
      "trust_assets.2.asset_description": [
        {
          page: 1,
          bbox: {
            left: 0.1437908496732026,
            top: 0.4810606060606061,
            width: 0.20380555555555557,
            height: 0.009659090909090909,
          },
        },
      ],
      "trust_assets.3.asset_description": [
        {
          page: 1,
          bbox: {
            left: 0.1437908496732026,
            top: 0.49747474747474746,
            width: 0.16011111111111112,
            height: 0.009659090909090909,
          },
        },
      ],
      "trust_assets.4.asset_description": [
        {
          page: 1,
          bbox: {
            left: 0.1437908496732026,
            top: 0.5138888888888888,
            width: 0.22383333333333336,
            height: 0.009659090909090909,
          },
        },
      ],
      "beneficiaries.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6123737373737373,
            width: 0.17463888888888887,
            height: 0.009927398989898991,
          },
        },
      ],
      "beneficiaries.1.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6287878787878788,
            width: 0.15298611111111113,
            height: 0.009927398989898991,
          },
        },
      ],
      "beneficiaries.2.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6452020202020202,
            width: 0.17076388888888888,
            height: 0.009927398989898991,
          },
        },
      ],
      "beneficiaries.3.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.6616161616161617,
            width: 0.11211111111111112,
            height: 0.009927398989898991,
          },
        },
      ],
      "beneficiaries.4.name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.678030303030303,
            width: 0.15786111111111112,
            height: 0.009927398989898991,
          },
        },
      ],
      "trust_provisions.has_spendthrift_clause": [
        {
          page: 1,
          bbox: {
            left: 0.38235294117647056,
            top: 0.7222222222222222,
            width: 0.28891666666666665,
            height: 0.009927398989898991,
          },
        },
      ],
      "trust_provisions.distribution_standard": [
        {
          page: 1,
          bbox: {
            left: 0.38235294117647056,
            top: 0.7386363636363636,
            width: 0.2688611111111111,
            height: 0.009927398989898991,
          },
        },
      ],
    },
    createdAt: "2026-02-18T11:30:00.000Z",
  },
  1004: {
    id: 1004,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "Chase_Bank_Statement_Feb2026.pdf",
    displayName: "Chase Bank Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Chase joint checking statement for February 2026 showing a balance of $34,820.16. Account held jointly with Robert Arthur Whitfield. Notable activity includes a $2,500 retainer payment and $3,240 property tax payment.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      institution_name: "Chase Bank, N.A.",
      account_type: "Joint Checking",
      balance: 34820.16,
      statement_date: "2026-02-28",
      joint_account_holders: ["Robert Arthur Whitfield"],
    },
    specificDocCitations: {
      institution_name: [
        {
          page: 1,
          bbox: {
            left: 0.453983660130719,
            top: 0.11237373737373738,
            width: 0.09090849673202615,
            height: 0.008175505050505051,
          },
        },
      ],
      account_type: [
        {
          page: 1,
          bbox: {
            left: 0.6898300653594771,
            top: 0.11237373737373738,
            width: 0.07478104575163397,
            height: 0.008175505050505051,
          },
        },
      ],
      balance: [
        {
          page: 1,
          bbox: {
            left: 0.7678692810457516,
            top: 0.22095959595959597,
            width: 0.13082352941176473,
            height: 0.01868686868686869,
          },
        },
      ],
      statement_date: [
        {
          page: 1,
          bbox: {
            left: 0.2142295751633987,
            top: 0.2777777777777778,
            width: 0.11369444444444445,
            height: 0.009927398989898991,
          },
        },
      ],
      joint_account_holders: [
        {
          page: 1,
          bbox: {
            left: 0.6378088235294118,
            top: 0.2777777777777778,
            width: 0.1410277777777778,
            height: 0.009927398989898991,
          },
        },
      ],
    },
    createdAt: "2026-02-24T14:00:00.000Z",
  },
  1005: {
    id: 1005,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Vanguard_IRA_Statement_Q42025.pdf",
    displayName: "Vanguard IRA Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Vanguard IRA statement for Q4 2025. Traditional IRA (xxxxxx7821) valued at $612,485 with Robert Arthur Whitfield as TOD beneficiary. Roth IRA (xxxxxx7822) valued at $94,650. Primary holdings concentrated in Vanguard index funds.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      institution_name: "Vanguard",
      statement_date: "2025-12-31",
      accounts: [
        {
          account_type: "Traditional IRA",
          total_value: 612485,
          tod_beneficiaries: ["Robert Arthur Whitfield"],
          holdings: [
            {
              company_name: "Vanguard Total Stock Market Index",
              ticker: "VTSAX",
              shares: 12480,
              market_value: 487872,
            },
            {
              company_name: "Vanguard Total Bond Market II Index",
              ticker: "VTBIX",
              shares: 2000,
              market_value: 102240,
            },
            {
              company_name: "Vanguard Short-Term Inflation-Protected Securities",
              ticker: "VTAPX",
              shares: 442,
              market_value: 22373,
            },
          ],
        },
        {
          account_type: "Roth IRA",
          total_value: 94650,
        },
      ],
    },
    specificDocCitations: {
      institution_name: [
        {
          page: 1,
          bbox: {
            left: 0.18196568627450982,
            top: 0.13383838383838384,
            width: 0.059250000000000004,
            height: 0.009927398989898991,
          },
        },
      ],
      statement_date: [
        {
          page: 1,
          bbox: {
            left: 0.5737066993464052,
            top: 0.13383838383838384,
            width: 0.12197222222222223,
            height: 0.009927398989898991,
          },
        },
      ],
      "accounts.0.total_value": [
        {
          page: 1,
          bbox: {
            left: 0.7533333333333334,
            top: 0.24621212121212122,
            width: 0.14535947712418298,
            height: 0.01868686868686869,
          },
        },
      ],
      "accounts.0.tod_beneficiaries": [
        {
          page: 1,
          bbox: {
            left: 0.32765359477124184,
            top: 0.22727272727272727,
            width: 0.25,
            height: 0.014,
          },
        },
      ],
      "accounts.0.holdings.0.company_name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.33207070707070707,
            width: 0.35,
            height: 0.014,
          },
        },
      ],
      "accounts.1.total_value": [
        {
          page: 1,
          bbox: {
            left: 0.7678692810457516,
            top: 0.49873737373737376,
            width: 0.13082352941176473,
            height: 0.01868686868686869,
          },
        },
      ],
    },
    createdAt: "2026-02-28T09:00:00.000Z",
  },
  1006: {
    id: 1006,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Fidelity_401k_Statement_Q42025.pdf",
    displayName: "Fidelity 401(k) Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Fidelity 401(k) statement for Q4 2025 showing a total value of $185,200. Robert Arthur Whitfield listed as TOD beneficiary. Portfolio holds Fidelity index funds across equity and bond allocations.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      institution_name: "Fidelity Investments",
      statement_date: "2025-12-31",
      accounts: [
        {
          account_type: "401(k)",
          total_value: 185200,
          tod_beneficiaries: ["Robert Arthur Whitfield"],
          holdings: [
            {
              company_name: "Fidelity 500 Index Fund",
              ticker: "FXAIX",
              shares: 420,
              market_value: 110236,
            },
            {
              company_name: "Fidelity US Bond Index Fund",
              ticker: "FXNAX",
              shares: 1120,
              market_value: 11155,
            },
            {
              company_name: "Fidelity Total Market Index",
              ticker: "FSKAX",
              shares: 682,
              market_value: 63809,
            },
          ],
        },
      ],
    },
    specificDocCitations: {
      institution_name: [
        {
          page: 1,
          bbox: {
            left: 0.18196568627450982,
            top: 0.13383838383838384,
            width: 0.12209722222222222,
            height: 0.009927398989898991,
          },
        },
      ],
      statement_date: [
        {
          page: 1,
          bbox: {
            left: 0.5737066993464052,
            top: 0.13383838383838384,
            width: 0.12197222222222223,
            height: 0.009927398989898991,
          },
        },
      ],
      "accounts.0.total_value": [
        {
          page: 1,
          bbox: {
            left: 0.7533333333333334,
            top: 0.2638888888888889,
            width: 0.14535947712418298,
            height: 0.01868686868686869,
          },
        },
      ],
      "accounts.0.tod_beneficiaries": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.2474747474747475,
            width: 0.3,
            height: 0.014,
          },
        },
      ],
      "accounts.0.holdings.0.company_name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.34974747474747475,
            width: 0.35,
            height: 0.014,
          },
        },
      ],
    },
    createdAt: "2026-03-01T10:00:00.000Z",
  },
  1007: {
    id: 1007,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Schwab_Brokerage_Statement_Q42025.pdf",
    displayName: "Charles Schwab Brokerage Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Charles Schwab individual brokerage statement for Q4 2025. Account (xxxxxx8847) valued at $178,900, held in revocable trust. Holdings include Apple, Microsoft, Vanguard S&P 500 ETF, and AGG bond ETF.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      institution_name: "Charles Schwab",
      statement_date: "2025-12-31",
      accounts: [
        {
          account_type: "Individual brokerage account",
          total_value: 178900,
          holdings: [
            {
              company_name: "Apple Inc.",
              ticker: "AAPL",
              shares: 185,
              market_value: 43588,
            },
            {
              company_name: "Microsoft Corporation",
              ticker: "MSFT",
              shares: 88,
              market_value: 33836,
            },
            {
              company_name: "Vanguard S&P 500 ETF",
              ticker: "VOO",
              shares: 82,
              market_value: 39524,
            },
            {
              company_name: "iShares Core US Agg Bond ETF",
              ticker: "AGG",
              shares: 620,
              market_value: 61952,
            },
          ],
        },
      ],
    },
    specificDocCitations: {
      institution_name: [
        {
          page: 1,
          bbox: {
            left: 0.18196568627450982,
            top: 0.13383838383838384,
            width: 0.10111111111111111,
            height: 0.009927398989898991,
          },
        },
      ],
      statement_date: [
        {
          page: 1,
          bbox: {
            left: 0.5737066993464052,
            top: 0.13383838383838384,
            width: 0.12197222222222223,
            height: 0.009927398989898991,
          },
        },
      ],
      "accounts.0.total_value": [
        {
          page: 1,
          bbox: {
            left: 0.7533333333333334,
            top: 0.24621212121212122,
            width: 0.14535947712418298,
            height: 0.01868686868686869,
          },
        },
      ],
      "accounts.0.holdings.0.company_name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.33207070707070707,
            width: 0.3,
            height: 0.014,
          },
        },
      ],
    },
    createdAt: "2026-03-02T10:00:00.000Z",
  },
  1008: {
    id: 1008,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Fidelity_Joint_Brokerage_Q42025.pdf",
    displayName: "Fidelity Joint Brokerage Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Fidelity joint brokerage statement for Q4 2025. Account (xxxxxx5520) valued at $285,400, held jointly with Robert Arthur Whitfield. Primarily invested in the Fidelity 500 Index and AGG bond ETF.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      institution_name: "Fidelity Investments",
      statement_date: "2025-12-31",
      accounts: [
        {
          account_type: "Individual brokerage account",
          total_value: 285400,
          joint_account_holders: ["Robert Arthur Whitfield"],
          holdings: [
            {
              company_name: "Fidelity 500 Index Fund",
              ticker: "FXAIX",
              shares: 800,
              market_value: 209976,
            },
            {
              company_name: "iShares Core US Agg Bond ETF",
              ticker: "AGG",
              shares: 750,
              market_value: 74925,
            },
            {
              company_name: "Vanguard Short-Term Bond ETF",
              ticker: "BSV",
              shares: 11,
              market_value: 499,
            },
          ],
        },
      ],
    },
    specificDocCitations: {
      institution_name: [
        {
          page: 1,
          bbox: {
            left: 0.18196568627450982,
            top: 0.13383838383838384,
            width: 0.12209722222222222,
            height: 0.009927398989898991,
          },
        },
      ],
      statement_date: [
        {
          page: 1,
          bbox: {
            left: 0.5737066993464052,
            top: 0.13383838383838384,
            width: 0.12197222222222223,
            height: 0.009927398989898991,
          },
        },
      ],
      "accounts.0.total_value": [
        {
          page: 1,
          bbox: {
            left: 0.7533333333333334,
            top: 0.24621212121212122,
            width: 0.14535947712418298,
            height: 0.01868686868686869,
          },
        },
      ],
      "accounts.0.joint_account_holders": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.24494949494949494,
            width: 0.3,
            height: 0.014,
          },
        },
      ],
      "accounts.0.holdings.0.company_name": [
        {
          page: 1,
          bbox: {
            left: 0.0915032679738562,
            top: 0.33207070707070707,
            width: 0.3,
            height: 0.014,
          },
        },
      ],
    },
    createdAt: "2026-03-03T10:00:00.000Z",
  },
  1009: {
    id: 1009,
    extractionStatus: "completed",
    documentType: "insurance_document",
    fileName: "Northwestern_Mutual_Policy_NM7728416.pdf",
    displayName: "Northwestern Mutual Life Insurance Policy",
    smartSummary: {
      status: "completed",
      summary:
        "Northwestern Mutual 20-year term life insurance policy (NM-77-2841-6) with a $250,000 face value. Policy in force through January 15, 2036. Robert Arthur Whitfield is the 100% primary beneficiary. Three children named as equal contingent beneficiaries.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      insurance_company_name: "Northwestern Mutual Life Insurance Company",
      policy_number: "NM-77-2841-6",
      policy_type: "Term Life Insurance (20-Year)",
      face_value: 250000,
      insured_person: "Margaret Eleanor Whitfield",
      policy_owner: "Margaret Eleanor Whitfield",
      policy_effective_date: "2016-01-15",
      policy_expiration_date: "2036-01-15",
      premium_amount: 892,
      premium_frequency: "Quarterly",
      primary_beneficiaries: [
        {
          name: "Robert Arthur Whitfield",
          relationship: "Spouse",
          percentage: 100,
        },
      ],
      contingent_beneficiaries: [
        {
          name: "Catherine Whitfield-Marsh",
          relationship: "Daughter",
          percentage: 33.33,
        },
        {
          name: "Andrew Whitfield",
          relationship: "Son",
          percentage: 33.33,
        },
        {
          name: "Rebecca Whitfield-Chen",
          relationship: "Daughter",
          percentage: 33.33,
        },
      ],
    },
    specificDocCitations: {
      policy_number: [
        {
          page: 1,
          bbox: {
            left: 0.18275326797385621,
            top: 0.09722222222222222,
            width: 0.07372875816993464,
            height: 0.008175505050505051,
          },
        },
      ],
      policy_type: [
        {
          page: 1,
          bbox: {
            left: 0.16249673202614381,
            top: 0.11237373737373738,
            width: 0.15004248366013073,
            height: 0.008175505050505051,
          },
        },
      ],
      face_value: [
        {
          page: 1,
          bbox: {
            left: 0.09803921568627451,
            top: 0.16414141414141414,
            width: 0.29071895424836597,
            height: 0.03737373737373738,
          },
        },
      ],
      insured_person: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.24242424242424243,
            width: 0.18491176470588236,
            height: 0.010511363636363638,
          },
        },
      ],
      policy_owner: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.2702020202020202,
            width: 0.18491176470588236,
            height: 0.010511363636363638,
          },
        },
      ],
      insurance_company_name: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.29797979797979796,
            width: 0.32098529411764704,
            height: 0.010511363636363638,
          },
        },
      ],
      policy_effective_date: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.32575757575757575,
            width: 0.11713235294117645,
            height: 0.010511363636363638,
          },
        },
      ],
      policy_expiration_date: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.35353535353535354,
            width: 0.11713235294117645,
            height: 0.010511363636363638,
          },
        },
      ],
      premium_amount: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.3813131313131313,
            width: 0.05314705882352941,
            height: 0.010511363636363638,
          },
        },
      ],
      premium_frequency: [
        {
          page: 1,
          bbox: {
            left: 0.42287581699346405,
            top: 0.4090909090909091,
            width: 0.06545588235294117,
            height: 0.010511363636363638,
          },
        },
      ],
      "primary_beneficiaries.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.24509803921568626,
            top: 0.47853535353535354,
            width: 0.16198529411764706,
            height: 0.010511363636363638,
          },
        },
      ],
      "contingent_beneficiaries.0.name": [
        {
          page: 1,
          bbox: {
            left: 0.24509803921568626,
            top: 0.5012626262626263,
            width: 0.18080882352941174,
            height: 0.010511363636363638,
          },
        },
      ],
    },
    createdAt: "2026-03-05T14:00:00.000Z",
  },
  1010: {
    id: 1010,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "NY529_Account_Statement_2025.pdf",
    displayName: "NY 529 College Savings Account Statement",
    smartSummary: {
      status: "completed",
      summary:
        "New York 529 Direct Plan statement covering six college savings accounts totaling $270,000 ($45,000 per grandchild). Account owner: Margaret Eleanor Whitfield. Invested in age-based conservative strategy. Total 2025 earnings: $18,420.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      plan_sponsor: "NY State Higher Education Services Corporation",
      account_type: "529 College Savings (6 Accounts)",
      total_account_value: 270000,
      statement_period: "January 1 – December 31, 2025",
      account_owner: "Margaret Eleanor Whitfield",
      investment_strategy: "Age-Based Conservative (Vanguard)",
      total_earnings_ytd: 18420,
      contributions_ytd: 0,
      beneficiary: "Eleanor Marsh (and 5 other grandchildren)",
    },
    specificDocCitations: {},
    createdAt: "2026-03-06T10:00:00.000Z",
  },
  1011: {
    id: 1011,
    extractionStatus: "completed",
    documentType: "tax_document",
    fileName: "2025_Federal_Tax_Return_1040.pdf",
    displayName: "2025 Federal Income Tax Return (Form 1040)",
    smartSummary: {
      status: "completed",
      summary:
        "2025 federal income tax return filed jointly by Margaret and Robert Whitfield. Adjusted gross income of $284,500 derived primarily from IRA distributions, dividends, capital gains, and Social Security. Total tax liability: $52,840 with a refund of $3,640.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      taxpayer_name: "Margaret Eleanor Whitfield",
      spouse_name: "Robert Arthur Whitfield",
      filing_status: "Married Filing Jointly",
      tax_year: "2025",
      adjusted_gross_income: 284500,
      taxable_income: 232400,
      total_tax: 52840,
      federal_income_tax_withheld: 48200,
      refund_amount: 3640,
      ira_distributions: 42000,
      interest_income: 8200,
      dividend_income: 31400,
      capital_gains: 18900,
      social_security_benefits: 28400,
    },
    specificDocCitations: {
      interest_income: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.2777777777777778,
            width: 0.06541176470588235,
            height: 0.010511363636363638,
          },
        },
      ],
      dividend_income: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.3005050505050505,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      ira_distributions: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.32323232323232326,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      social_security_benefits: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.34595959595959597,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      capital_gains: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.3686868686868687,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      adjusted_gross_income: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.3952020202020202,
            width: 0.09084967320261438,
            height: 0.01167929292929293,
          },
        },
      ],
      taxable_income: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.4444444444444444,
            width: 0.08176470588235293,
            height: 0.010511363636363638,
          },
        },
      ],
      total_tax: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.4671717171717172,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      federal_income_tax_withheld: [
        {
          page: 1,
          bbox: {
            left: 0.7810457516339869,
            top: 0.4898989898989899,
            width: 0.07358823529411763,
            height: 0.010511363636363638,
          },
        },
      ],
      refund_amount: [
        {
          page: 1,
          bbox: {
            left: 0.7549019607843137,
            top: 0.5429292929292929,
            width: 0.1308235294117647,
            height: 0.021022727272727276,
          },
        },
      ],
    },
    createdAt: "2026-03-10T09:00:00.000Z",
  },
  1012: {
    id: 1012,
    extractionStatus: "completed",
    documentType: "mortgage_statement",
    fileName: "KeyBank_Mortgage_Statement_Feb2026.pdf",
    displayName: "KeyBank Mortgage Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "KeyBank mortgage statement for February 2026. Remaining principal balance: $268,742.16 on the Bedford residence at 47 Hawthorne Lane. 30-year fixed rate at 4.125%, monthly payment $1,842.60. Loan originated September 2016, matures October 2046.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      lender: "KeyBank National Association",
      property_address: "47 Hawthorne Lane, Bedford, NY 10506",
      loan_number: "xxxxxx0604",
      principal_balance: 268742.16,
      interest_rate: "4.125%",
      monthly_payment: 1842.6,
      payment_due_date: "2026-03-01",
      escrow_balance: 3420.88,
      original_loan_amount: 380000,
      origination_date: "2016-09-15",
      maturity_date: "2046-10-01",
    },
    specificDocCitations: {
      payment_due_date: [
        {
          page: 1,
          bbox: {
            left: 0.244390522875817,
            top: 0.1717171717171717,
            width: 0.0954264705882353,
            height: 0.010511363636363638,
          },
        },
      ],
      monthly_payment: [
        {
          page: 1,
          bbox: {
            left: 0.39815686274509804,
            top: 0.1893939393939394,
            width: 0.1017516339869281,
            height: 0.016351010101010102,
          },
        },
      ],
      lender: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.2878787878787879,
            width: 0.21202941176470588,
            height: 0.010511363636363638,
          },
        },
      ],
      property_address: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.31565656565656564,
            width: 0.2711176470588235,
            height: 0.010511363636363638,
          },
        },
      ],
      original_loan_amount: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.3434343434343434,
            width: 0.08176470588235293,
            height: 0.010511363636363638,
          },
        },
      ],
      origination_date: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.3712121212121212,
            width: 0.13673529411764704,
            height: 0.010511363636363638,
          },
        },
      ],
      maturity_date: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.398989898989899,
            width: 0.10894117647058824,
            height: 0.010511363636363638,
          },
        },
      ],
      interest_rate: [
        {
          page: 1,
          bbox: {
            left: 0.46470588235294114,
            top: 0.42676767676767674,
            width: 0.09222058823529411,
            height: 0.010511363636363638,
          },
        },
      ],
      principal_balance: [
        {
          page: 1,
          bbox: {
            left: 0.7549019607843137,
            top: 0.4823232323232323,
            width: 0.10901960784313726,
            height: 0.014015151515151517,
          },
        },
      ],
      escrow_balance: [
        {
          page: 1,
          bbox: {
            left: 0.7549019607843137,
            top: 0.5429292929292929,
            width: 0.06541176470588235,
            height: 0.010511363636363638,
          },
        },
      ],
    },
    createdAt: "2026-03-12T11:00:00.000Z",
  },
};

export const DEMO_DOCUMENT_URLS: Record<number, string> = {
  1001: "/demo/documents/death_certificate.pdf",
  1002: "/demo/documents/will.pdf",
  1003: "/demo/documents/trust.pdf",
  1004: "/demo/documents/chase_feb.pdf",
  1005: "/demo/documents/vanguard_ira.pdf",
  1006: "/demo/documents/fidelity_401k.pdf",
  1007: "/demo/documents/schwab_brokerage.pdf",
  1008: "/demo/documents/fidelity_brokerage.pdf",
  1009: "/demo/documents/nm_insurance.pdf",
  1010: "/demo/documents/ny529.pdf",
  1011: "/demo/documents/tax_return_1040.pdf",
  1012: "/demo/documents/keybank_mortgage.pdf",
};

export const DEMO_DOCUMENT_METADATA_2: Record<number, DocumentViewMetadata> = {
  6001: {
    id: 6001,
    extractionStatus: "completed",
    documentType: "death_certificate",
    fileName: "Death_Certificate_Gerald_Ashford.pdf",
    displayName: "Death Certificate",
    smartSummary: {
      status: "completed",
      summary:
        "Death certificate for Gerald Thomas Ashford, aged 78, who passed on March 4, 2026 in Chapel Hill, NC (Orange County). Marital status: Widowed. Certificate 2026-NC-03-01847 issued March 16, 2026. Informant: Diane Ashford-Nguyen (Daughter).",
    },
    documentExtraction: null,
    specificDocExtraction: {
      decedent_information: {
        date_of_birth: "March 12, 1947",
        date_of_death: "March 4, 2026",
        place_of_death: "Chapel Hill, NC (Orange County)",
        marital_status: "Widowed",
        age_at_death: "78",
        sex: "Male",
        residence_address: "612 Coker Ridge Road, Chapel Hill, NC 27516",
      },
      administrative_information: {
        certificate_number: "2026-NC-03-01847",
        date_issued: "March 16, 2026",
        state_filed: "North Carolina",
        county_filed: "Orange County",
        registrar_name: "Alice M. Turnbull",
      },
      other_details: {
        occupation: "Retired Civil Engineer",
        birthplace: "Greensboro, North Carolina",
        education_level: "Bachelor's Degree",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-04T19:00:00.000Z",
  },
  6002: {
    id: 6002,
    extractionStatus: "completed",
    documentType: "will",
    fileName: "Last_Will_and_Testament_GTA_2022.pdf",
    displayName: "Last Will and Testament",
    smartSummary: {
      status: "completed",
      summary:
        "Last Will and Testament of Gerald Thomas Ashford, executed June 9, 2022 in North Carolina. Self-proving. Appoints Diane Ashford-Nguyen as primary executor, Marcus Ashford as successor. Specific bequests: 1974 MGB and woodworking shop to Marcus; coin collection ($18,500) to Wesley Nguyen (UTMA). Residuary estate split equally among three children.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      will_information: {
        testator: "Gerald Thomas Ashford",
        date_signed: "June 9, 2022",
        state: "North Carolina",
        self_proving: "Yes",
        revokes_prior_wills: "Yes",
      },
      executor: {
        primary: "Diane Ashford-Nguyen (Daughter)",
        successor: "Marcus Ashford (Son)",
      },
      residuary_beneficiaries: [
        { name: "Diane Ashford-Nguyen", relationship: "Daughter", share: "33.34%" },
        { name: "Marcus Ashford", relationship: "Son", share: "33.33%" },
        { name: "Laura Ashford-Pruitt", relationship: "Daughter", share: "33.33%" },
      ],
    },
    specificDocCitations: {},
    createdAt: "2026-03-20T11:00:00.000Z",
  },
  6003: {
    id: 6003,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "FirstCitizens_Checking_Statement_Feb2026.pdf",
    displayName: "First Citizens Checking Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "First Citizens Bank personal checking statement for Gerald T. Ashford, account ending 2417. Statement period February 2026. Ending balance $18,450.33. POD designation to Diane Ashford-Nguyen. Notable: SSA and NC TSERS pension deposits, HELOC payment $241.18.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        account_type: "Personal Checking",
        account_number: "XXXXXX2417",
        statement_date: "February 28, 2026",
      },
      balances: {
        ending_balance: "$18,450.33",
      },
      beneficiary: "Payable on Death (POD) — Diane Ashford-Nguyen",
    },
    specificDocCitations: {},
    createdAt: "2026-03-21T10:00:00.000Z",
  },
  6004: {
    id: 6004,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Fidelity_IRA_Statement_Q42025.pdf",
    displayName: "Fidelity IRA Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Fidelity retirement account statement Q4 2025 for Gerald T. Ashford. Traditional IRA (rollover) XXXXXX-T-6642 valued at $232,640. Roth IRA XXXXXX-R-6643 valued at $38,750. Combined retirement assets: $271,390. 2025 RMD of $11,240 satisfied. Beneficiaries: three children equally.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        statement_date: "December 31, 2025",
      },
      accounts: [
        {
          type: "Traditional IRA (Rollover)",
          account_number: "XXXXXX-T-6642",
          value: "$232,640.00",
        },
        { type: "Roth IRA", account_number: "XXXXXX-R-6643", value: "$38,750.00" },
      ],
      total_value: "$271,390.00",
    },
    specificDocCitations: {},
    createdAt: "2026-03-21T11:00:00.000Z",
  },
  6005: {
    id: 6005,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Schwab_Brokerage_Statement_Q42025.pdf",
    displayName: "Charles Schwab Brokerage Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Charles Schwab individual brokerage statement Q4 2025 for Gerald T. Ashford. Account XXXXXX-I-3318 valued at $118,400. TOD registration to three children equally. Holdings: VOO, JNJ, AGG, plus cash. 2025 dividends: $2,940 ordinary, $2,105 qualified.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        account_number: "XXXXXX-I-3318",
        account_type: "Individual Brokerage",
        registration: "Transfer on Death (TOD)",
        statement_date: "December 31, 2025",
      },
      balances: {
        total_value: "$118,400.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-21T12:00:00.000Z",
  },
  6006: {
    id: 6006,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "Truist_Savings_Statement_Feb2026.pdf",
    displayName: "Truist Savings Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Truist Bank personal savings statement for Gerald T. Ashford, account ending 8809. February 2026 ending balance $62,300.18. APY 3.85%. Interest paid 2025: $2,412.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        account_type: "Personal Savings",
        account_number: "XXXXXX8809",
        statement_date: "February 28, 2026",
      },
      balances: {
        ending_balance: "$62,300.18",
      },
      interest: {
        apy: "3.85%",
        interest_2025: "$2,412.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-22T09:00:00.000Z",
  },
  6007: {
    id: 6007,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "Ally_CD_Statement_2026.pdf",
    displayName: "Ally Bank CD Statement — 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Ally Bank 18-month high yield CD for Gerald T. Ashford, account ending 5531. Principal balance $40,000. APY 4.40%. Opened May 2025, matures November 2026. POD to three children equally.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        account_type: "18-Month High Yield CD",
        account_number: "XXXXXX5531",
      },
      certificate: {
        principal: "$40,000.00",
        apy: "4.40%",
        date_opened: "May 12, 2025",
        maturity_date: "November 12, 2026",
      },
      beneficiary:
        "POD — Diane Ashford-Nguyen (33.34%), Marcus Ashford (33.33%), Laura Ashford-Pruitt (33.33%)",
    },
    specificDocCitations: {},
    createdAt: "2026-03-22T10:00:00.000Z",
  },
  6008: {
    id: 6008,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "FirstCitizens_HELOC_Statement_Feb2026.pdf",
    displayName: "First Citizens HELOC Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "First Citizens Bank HELOC statement for Gerald T. Ashford, loan 3391-70558-02. Property: 612 Coker Ridge Road, Chapel Hill. Outstanding balance $38,214.67. Credit line $75,000. Variable rate 7.50%. Interest only minimum $241.18/mo. Current status.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      loan_information: {
        borrower: "Gerald T. Ashford",
        loan_number: "3391-70558-02",
        property_address: "612 Coker Ridge Road, Chapel Hill, NC 27516",
      },
      balances: {
        outstanding_balance: "$38,214.67",
        credit_line: "$75,000.00",
        available_credit: "$36,785.33",
      },
      terms: {
        interest_rate: "7.50% variable",
        minimum_payment: "$241.18",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-22T11:00:00.000Z",
  },
  6009: {
    id: 6009,
    extractionStatus: "completed",
    documentType: "credit_card_statement",
    fileName: "Truist_Visa_Statement_Feb2026.pdf",
    displayName: "Truist Visa Statement — February 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Truist Visa Signature statement for Gerald T. Ashford, card ending 4471. Statement closing February 20, 2026. New balance $2,183.42. Diane Ashford-Nguyen listed as authorized user only (not account holder). Credit limit $15,000.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Gerald T. Ashford",
        account_number: "XXXX XXXX XXXX 4471",
        authorized_user: "Diane Ashford-Nguyen (authorized user only)",
      },
      balances: {
        new_balance: "$2,183.42",
        credit_limit: "$15,000.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-22T12:00:00.000Z",
  },
  6010: {
    id: 6010,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "NC529_Account_Statement_2025.pdf",
    displayName: "NC 529 Plan Statement — 2025",
    smartSummary: {
      status: "completed",
      summary:
        "NC 529 Plan statement for Gerald T. Ashford as account owner. Three accounts for grandchildren: Claire Nguyen ($24,000), Wesley Nguyen ($20,000), Tessa Ashford ($16,000). Total $60,000. Successor account owner: Diane Ashford-Nguyen. 2025 earnings $3,180.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_owner: "Gerald T. Ashford",
        successor_owner: "Diane Ashford-Nguyen",
        statement_date: "December 31, 2025",
      },
      accounts: [
        { beneficiary: "Claire Nguyen", value: "$24,000.00" },
        { beneficiary: "Wesley Nguyen", value: "$20,000.00" },
        { beneficiary: "Tessa Ashford", value: "$16,000.00" },
      ],
      total_value: "$60,000.00",
    },
    specificDocCitations: {},
    createdAt: "2026-03-23T09:00:00.000Z",
  },
  6011: {
    id: 6011,
    extractionStatus: "completed",
    documentType: "insurance_document",
    fileName: "StateFarm_Life_Policy_SF8844721.pdf",
    displayName: "State Farm Whole Life Policy (SF-88-4472-1)",
    smartSummary: {
      status: "completed",
      summary:
        "State Farm whole life insurance policy SF-88-4472-1 for Gerald Thomas Ashford. Face value $100,000. Fully paid up since 2018. Cash value $46,280 as of 12/31/2025. Primary beneficiaries: three children equally (updated October 2021 after Nancy's death). Contingent: grandchildren per stirpes.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      policy_information: {
        insured: "Gerald Thomas Ashford",
        policy_number: "SF-88-4472-1",
        policy_type: "Whole Life",
        effective_date: "March 1, 1988",
        face_value: "$100,000.00",
        cash_value: "$46,280.00",
        premium_status: "Fully paid up (2018)",
      },
      beneficiaries: {
        primary:
          "Diane Ashford-Nguyen (33.34%), Marcus Ashford (33.33%), Laura Ashford-Pruitt (33.33%)",
        contingent: "Grandchildren, per stirpes",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-23T10:00:00.000Z",
  },
  6012: {
    id: 6012,
    extractionStatus: "completed",
    documentType: "tax_document",
    fileName: "2025_Federal_Tax_Return_1040_GTA.pdf",
    displayName: "2025 Federal Tax Return (Form 1040)",
    smartSummary: {
      status: "completed",
      summary:
        "2025 federal tax return (Form 1040) for Gerald Thomas Ashford (deceased 03/04/2026). Filed by Diane Ashford-Nguyen as personal representative. Filing status: Single. AGI $77,081. Income: pension $28,400, Social Security $26,418 (taxable), IRA distributions $11,240, interest $4,233, dividends $2,940. Refund $688.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      taxpayer: {
        name: "Gerald Thomas Ashford",
        filing_status: "Single",
        home_address: "612 Coker Ridge Road, Chapel Hill, NC 27516",
        deceased: "03/04/2026",
      },
      income: {
        agi: "$77,081.00",
        interest: "$4,233.00",
        dividends: "$2,940.00",
        ira_distributions: "$11,240.00",
        pensions: "$28,400.00",
        social_security_taxable: "$26,418.00",
      },
      tax: {
        total_tax: "$8,412.00",
        refund: "$688.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-23T11:00:00.000Z",
  },
  6013: {
    id: 6013,
    extractionStatus: "completed",
    documentType: "will",
    fileName: "Last_Will_and_Testament_MEW_2023.pdf",
    displayName: "Last Will and Testament — Margaret E. Whitfield (2023)",
    smartSummary: {
      status: "completed",
      summary:
        "Last Will and Testament of Margaret Eleanor Whitfield, executed November 14, 2023 in New York. Self-proving. Appoints Robert Arthur Whitfield (spouse) as primary executor, Catherine Whitfield-Marsh as successor. Specific bequests: jewelry to daughters, Lexus to spouse, Skaneateles furnishings to Andrew. Residuary: 50% spouse, 16.67% each child.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      will_information: {
        testator: "Margaret Eleanor Whitfield",
        date_signed: "November 14, 2023",
        state: "New York",
        self_proving: "Yes",
      },
      executor: {
        primary: "Robert Arthur Whitfield (Spouse)",
        successor: "Catherine Whitfield-Marsh (Daughter)",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-03-23T12:00:00.000Z",
  },
};

export const DEMO_DOCUMENT_URLS_2: Record<number, string> = {
  6001: "/demo/documents/ashford/Death_Certificate_Gerald_Ashford.pdf",
  6002: "/demo/documents/ashford/Last_Will_and_Testament_GTA_2022.pdf",
  6003: "/demo/documents/ashford/FirstCitizens_Checking_Statement_Feb2026.pdf",
  6004: "/demo/documents/ashford/Fidelity_IRA_Statement_Q42025.pdf",
  6005: "/demo/documents/ashford/Schwab_Brokerage_Statement_Q42025.pdf",
  6006: "/demo/documents/ashford/Truist_Savings_Statement_Feb2026.pdf",
  6007: "/demo/documents/ashford/Ally_CD_Statement_2026.pdf",
  6008: "/demo/documents/ashford/FirstCitizens_HELOC_Statement_Feb2026.pdf",
  6009: "/demo/documents/ashford/Truist_Visa_Statement_Feb2026.pdf",
  6010: "/demo/documents/ashford/NC529_Account_Statement_2025.pdf",
  6011: "/demo/documents/ashford/StateFarm_Life_Policy_SF8844721.pdf",
  6012: "/demo/documents/ashford/2025_Federal_Tax_Return_1040_GTA.pdf",
  6013: "/demo/documents/ashford/Last_Will_and_Testament_MEW_2023.pdf",
};

export const DEMO_DOCUMENT_METADATA_3: Record<number, DocumentViewMetadata> = {
  6101: {
    id: 6101,
    extractionStatus: "completed",
    documentType: "death_certificate",
    fileName: "Death_Certificate_Sylvia_Delgado.pdf",
    displayName: "Death Certificate",
    smartSummary: {
      status: "completed",
      summary:
        "Death certificate for Sylvia Marie Delgado, aged 66, who passed on January 22, 2026 in Austin, TX (Travis County). Marital status: Divorced. Certificate 2026-TX-01-05392 issued February 3, 2026. Occupation: Business Owner — Landscaping Services. Informant: Monica Delgado-Reyes (Daughter).",
    },
    documentExtraction: null,
    specificDocExtraction: {
      decedent_information: {
        date_of_birth: "July 30, 1959",
        date_of_death: "January 22, 2026",
        place_of_death: "Austin, TX (Travis County)",
        marital_status: "Divorced",
        age_at_death: "66",
        sex: "Female",
        residence_address: "2604 Larkspur Valley Drive, Austin, TX 78704",
      },
      administrative_information: {
        certificate_number: "2026-TX-01-05392",
        date_issued: "February 3, 2026",
        state_filed: "Texas",
        county_filed: "Travis County",
        registrar_name: "R. E. Whitcomb",
      },
      other_details: {
        occupation: "Business Owner — Landscaping Services",
        birthplace: "San Antonio, Texas",
        education_level: "Bachelor's Degree",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-01-22T20:00:00.000Z",
  },
  6102: {
    id: 6102,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "Frost_Checking_Statement_Jan2026.pdf",
    displayName: "Frost Bank Checking Statement — January 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Frost Bank personal checking statement for Sylvia M. Delgado, account ending 7205. January 2026 ending balance $22,415.87. No beneficiary designation on file. Notable: DGM LLC owner distribution $6,000, mortgage payment $1,986.24.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Sylvia M. Delgado",
        account_type: "Personal Checking",
        account_number: "XXXXXX7205",
        statement_date: "January 31, 2026",
      },
      balances: {
        ending_balance: "$22,415.87",
      },
      beneficiary: "None on file",
    },
    specificDocCitations: {},
    createdAt: "2026-04-02T10:00:00.000Z",
  },
  6103: {
    id: 6103,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Schwab_SEPIRA_Statement_Q42025.pdf",
    displayName: "Charles Schwab SEP-IRA Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Charles Schwab SEP-IRA statement Q4 2025 for Sylvia M. Delgado. Account XXXXXX-S-9184 valued at $412,300. Employer plan: DGM LLC. CRITICAL: Beneficiary designation on file lists Raymond Delgado (ex-spouse) as 100% primary — designation dated May 3, 2004, never updated after 2009 divorce. Contingent beneficiaries: Monica and Daniel equally.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Sylvia M. Delgado",
        account_number: "XXXXXX-S-9184",
        account_type: "SEP-IRA",
        employer_plan: "Delgado Grounds Management LLC",
        statement_date: "December 31, 2025",
      },
      balances: {
        total_value: "$412,300.00",
      },
      beneficiary_designation: {
        primary: "Raymond Delgado (Spouse) — 100% — designated May 3, 2004",
        contingent: "Monica Delgado-Reyes (50%), Daniel Delgado (50%)",
        note: "Beneficiary designations have not been updated since May 3, 2004",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-02T11:00:00.000Z",
  },
  6104: {
    id: 6104,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Vanguard_Brokerage_Statement_Q42025.pdf",
    displayName: "Vanguard Individual Brokerage Statement — Q4 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Vanguard individual brokerage statement Q4 2025 for Sylvia M. Delgado. Account XXXXXX-I-2276 valued at $96,200. TOD registration to Monica Delgado-Reyes (50%) and Daniel Delgado (50%). Holdings: VTI, VXUS, BND, VMFXX.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Sylvia M. Delgado",
        account_number: "XXXXXX-I-2276",
        account_type: "Individual Brokerage",
        registration: "Transfer on Death (TOD)",
        statement_date: "December 31, 2025",
      },
      balances: {
        total_value: "$96,200.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-02T12:00:00.000Z",
  },
  6105: {
    id: 6105,
    extractionStatus: "completed",
    documentType: "mortgage_statement",
    fileName: "Amplify_Mortgage_Statement_Jan2026.pdf",
    displayName: "Amplify Credit Union Mortgage Statement — January 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Amplify Credit Union mortgage statement for Sylvia M. Delgado, loan 5502-88134-07. Property: 2604 Larkspur Valley Drive, Austin TX. Outstanding balance $214,608.39. Fixed 3.875%, 30-year. Monthly payment $1,986.24 with escrow. Current status.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      loan_information: {
        borrower: "Sylvia M. Delgado",
        loan_number: "5502-88134-07",
        property_address: "2604 Larkspur Valley Drive, Austin, TX 78704",
      },
      balances: {
        outstanding_balance: "$214,608.39",
        original_amount: "$273,600.00",
      },
      terms: {
        interest_rate: "3.875% fixed, 30-year",
        monthly_payment: "$1,986.24",
        maturity_date: "April 1, 2041",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-03T10:00:00.000Z",
  },
  6106: {
    id: 6106,
    extractionStatus: "completed",
    documentType: "bank_statement",
    fileName: "UFCU_Savings_Statement_Jan2026.pdf",
    displayName: "UFCU Savings Statement — January 2026",
    smartSummary: {
      status: "completed",
      summary:
        "University Federal Credit Union savings statement for Sylvia M. Delgado, account ending 3348. January 2026 ending balance $58,900.44. APY 3.90%. No beneficiary designation on file. Dividends paid 2025: $2,104.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        member: "Sylvia M. Delgado",
        account_type: "Membership Savings",
        account_number: "XXXXXX3348",
        statement_date: "January 31, 2026",
      },
      balances: {
        ending_balance: "$58,900.44",
      },
      beneficiary: "None on file",
    },
    specificDocCitations: {},
    createdAt: "2026-04-03T11:00:00.000Z",
  },
  6107: {
    id: 6107,
    extractionStatus: "completed",
    documentType: "investment_account_statement",
    fileName: "Coinbase_Statement_Jan2026.pdf",
    displayName: "Coinbase Account Statement — January 2026",
    smartSummary: {
      status: "completed",
      summary:
        "Coinbase account statement for Sylvia M. Delgado. January 2026. Portfolio: 0.42 BTC ($39,600) + 3.1 ETH ($8,250) = $47,850 total. No beneficiary designation exists. 2025 Form 1099-MISC: $312 staking rewards. Estate access requires death certificate + Letters through Coinbase support.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      account_information: {
        account_holder: "Sylvia M. Delgado",
        account_email: "s.delgado.atx@example.com",
        statement_date: "January 31, 2026",
      },
      holdings: [
        { asset: "Bitcoin (BTC)", quantity: "0.42000000", value: "$39,600.00" },
        { asset: "Ethereum (ETH)", quantity: "3.10000000", value: "$8,250.00" },
      ],
      total_value: "$47,850.00",
      beneficiary: "No beneficiary designation",
    },
    specificDocCitations: {},
    createdAt: "2026-04-03T12:00:00.000Z",
  },
  6108: {
    id: 6108,
    extractionStatus: "completed",
    documentType: "insurance_document",
    fileName: "Principal_Life_Policy_PL4490832.pdf",
    displayName: "Principal Life Term Policy (PL-44-9083-2)",
    smartSummary: {
      status: "completed",
      summary:
        "Principal Life 20-year level term policy PL-44-9083-2 for Sylvia Marie Delgado. Face value $150,000. Effective June 2015, expires June 2035. Annual premium $618. Original purpose: business loan protection. Beneficiaries: Monica (50%) and Daniel (50%), designated 2015 post-divorce.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      policy_information: {
        insured: "Sylvia Marie Delgado",
        policy_number: "PL-44-9083-2",
        policy_type: "20-Year Level Term",
        effective_date: "June 1, 2015",
        expiration_date: "June 1, 2035",
        face_value: "$150,000.00",
        annual_premium: "$618.00",
      },
      beneficiaries: {
        primary: "Monica Delgado-Reyes (50%), Daniel Delgado (50%)",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-04T09:00:00.000Z",
  },
  6109: {
    id: 6109,
    extractionStatus: "completed",
    documentType: "other",
    fileName: "DGM_LLC_Company_Agreement.pdf",
    displayName: "DGM LLC Company Agreement",
    smartSummary: {
      status: "completed",
      summary:
        "Company Agreement of Delgado Grounds Management LLC, amended April 2, 2013. Texas LLC formed January 10, 1994. Sole member: Sylvia Marie Delgado (100%). Member-managed. Commercial landscaping and grounds maintenance. Operating agreement is silent on death of sole member — membership interest passes through probate estate.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      company_information: {
        name: "Delgado Grounds Management LLC",
        state: "Texas",
        date_of_formation: "January 10, 1994",
        management: "Member-managed",
      },
      members: [{ name: "Sylvia Marie Delgado", interest: "100%" }],
    },
    specificDocCitations: {},
    createdAt: "2026-04-04T10:00:00.000Z",
  },
  6110: {
    id: 6110,
    extractionStatus: "completed",
    documentType: "tax_document",
    fileName: "DGM_LLC_2025_Schedule_K1.pdf",
    displayName: "Schedule K-1 (Form 1120-S) — DGM LLC 2025",
    smartSummary: {
      status: "completed",
      summary:
        "Schedule K-1 (Form 1120-S) for Delgado Grounds Management LLC, tax year 2025. Shareholder: Sylvia Marie Delgado (100%). Ordinary business income $138,500. Distributions $96,000. LLC taxed as S corporation since 2004.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      corporation: {
        name: "Delgado Grounds Management LLC",
        address: "9310 Burleson Road, Suite C, Austin, TX 78744",
      },
      shareholder: {
        name: "Sylvia Marie Delgado",
        ownership: "100%",
      },
      income: {
        ordinary_business_income: "$138,500.00",
        distributions: "$96,000.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-04T11:00:00.000Z",
  },
  6111: {
    id: 6111,
    extractionStatus: "completed",
    documentType: "tax_document",
    fileName: "2025_Federal_Tax_Return_1040_SMD.pdf",
    displayName: "2025 Federal Tax Return (Form 1040)",
    smartSummary: {
      status: "completed",
      summary:
        "2025 federal tax return (Form 1040) for Sylvia Marie Delgado (deceased 01/22/2026). Filed by Monica Delgado-Reyes as personal representative. Filing status: Single. AGI $142,834. Income: K-1 business income $138,500, staking rewards $312, interest $2,142, dividends $1,880. Refund $1,273.",
    },
    documentExtraction: null,
    specificDocExtraction: {
      taxpayer: {
        name: "Sylvia Marie Delgado",
        filing_status: "Single",
        home_address: "2604 Larkspur Valley Drive, Austin, TX 78704",
        deceased: "01/22/2026",
      },
      income: {
        agi: "$142,834.00",
        business_income: "$138,500.00",
        interest: "$2,142.00",
        dividends: "$1,880.00",
      },
      tax: {
        total_tax: "$23,527.00",
        refund: "$1,273.00",
      },
    },
    specificDocCitations: {},
    createdAt: "2026-04-04T12:00:00.000Z",
  },
};

export const DEMO_DOCUMENT_URLS_3: Record<number, string> = {
  6101: "/demo/documents/delgado/Death_Certificate_Sylvia_Delgado.pdf",
  6102: "/demo/documents/delgado/Frost_Checking_Statement_Jan2026.pdf",
  6103: "/demo/documents/delgado/Schwab_SEPIRA_Statement_Q42025.pdf",
  6104: "/demo/documents/delgado/Vanguard_Brokerage_Statement_Q42025.pdf",
  6105: "/demo/documents/delgado/Amplify_Mortgage_Statement_Jan2026.pdf",
  6106: "/demo/documents/delgado/UFCU_Savings_Statement_Jan2026.pdf",
  6107: "/demo/documents/delgado/Coinbase_Statement_Jan2026.pdf",
  6108: "/demo/documents/delgado/Principal_Life_Policy_PL4490832.pdf",
  6109: "/demo/documents/delgado/DGM_LLC_Company_Agreement.pdf",
  6110: "/demo/documents/delgado/DGM_LLC_2025_Schedule_K1.pdf",
  6111: "/demo/documents/delgado/2025_Federal_Tax_Return_1040_SMD.pdf",
};
